export default __webpack_public_path__ + "img/46cb7d4b356f96f7ba56278ed3f0bcbd.svg";